import { Formik } from 'formik'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '@/components/Button'
import { DateTimePicker } from '@/components/Form'
import ViewByFilterMap from '@/pages/SpaceAnalyticsPage/RelativeDateFilters/ViewByFilterMap'

import messages from './messages'

class DateRangeFilters extends Component<any, any> {
  static displayName = 'SpaceAnalyticsDateRangeFilters'

  static propTypes = {
    onChangeDateRangeFilters: PropTypes.func.isRequired,
    onApplyDateRangeFilters: PropTypes.func.isRequired,
    onCloseFilterOverlay: PropTypes.func.isRequired
  }

  state = {
    isAppliedEnabled: false,
    oldest: undefined,
    latest: undefined
  }

  componentDidUpdate = () => {
    const { oldest, latest, isAppliedEnabled } = this.state
    if (oldest && latest && !isAppliedEnabled) this.setState({ isAppliedEnabled: true })
  }

  determineInterval = (oldest: any, latest: any) => {
    const diff = moment(latest).diff(moment(oldest))
    const diffInDays = moment.duration(diff, 'milliseconds').asDays()

    if (diffInDays === 1) {
      return { interval: '1h', chartFormat: 'M/DD - ha' }
    } else if (diffInDays > 1 && diffInDays <= 7) {
      return { interval: '12h', chartFormat: 'ddd Do - ha' }
    } else if (diffInDays > 7 && diffInDays <= 31) {
      return { interval: '1d', chartFormat: 'MMM Do' }
    } else if (diffInDays > 31 && diffInDays <= 91) {
      return { interval: '1w', chartFormat: 'MMM Do YYYY' }
    } else if (diffInDays > 91) {
      return { interval: '1M', chartFormat: 'MMMM YYYY' }
    } else {
      return { interval: '1d', chartFormat: 'MMM Do' }
    }
  }

  isValidStartDateOption = (value: any) => {
    return value.isBefore(moment().subtract(1, 'day'), 'day') // Sets valid dates from yesterday and before
  }

  /**
   * Sets the end valid date from the start date until today
   *
   * @param value
   * @returns {boolean|boolean|*}
   */
  isValidEndDateOption = (value: any) => {
    const startDate = this.state.oldest
    if (startDate) return value.isAfter(moment(startDate), 'day') && value.isBefore(moment().add(1, 'day'), 'day')
    return value.isBefore(moment().add(1, 'day'), 'day')
  }

  onChangeDate = (id: any, value: any) => {
    this.setState({ [id]: value.toISOString() })
  }

  onApply = () => {
    const { oldest, latest } = this.state
    const params = {
      filterParams: {
        ...ViewByFilterMap.getViewByRangeItem('date-range'),
        oldest: oldest,
        latest: latest,
        difference: false,
        ...this.determineInterval(oldest, latest)
      },
      isDateRangeQuery: true,
      displayFilterOverlay: false
    }

    this.props.onApplyDateRangeFilters(params)
  }

  render() {
    const { onCloseFilterOverlay } = this.props
    const { isAppliedEnabled } = this.state

    return (
      <div className="date-range-filters">
        {/* @ts-expect-error */}
        <Formik
          initialValues={{
            start: '',
            end: ''
          }}
        >
          <div className="date_selects">
            <DateTimePicker
              onChange={event => this.onChangeDate('oldest', event)}
              isValid={this.isValidStartDateOption}
              className="right"
              label="Start Date:"
              name="start"
            />
            <DateTimePicker
              onChange={event => this.onChangeDate('latest', event)}
              isValid={this.isValidEndDateOption}
              label="End Date:"
              name="end"
            />
          </div>
        </Formik>
        <div className="buttons">
          <Button
            color="primary"
            onClick={() => {
              this.onApply()
            }}
            disabled={!isAppliedEnabled}
          >
            <FormattedMessage {...messages.apply} />
          </Button>
          <Button color="secondary" onClick={onCloseFilterOverlay}>
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </div>
    )
  }
}

export default DateRangeFilters
